export default "__VITE_ASSET__D4ZdSwT$__"